import React, { useState } from "react";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

const Whitepaper = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      <Header2 />
      <main className="main" style={{ paddingTop: "2rem", minHeight: "100vh" }}>
        <div className="whitepaper" style={{ 
          width: "98%",
          maxWidth: "98%",
          margin: "0 auto",
          padding: "0 1% 2rem"
        }}>
          {/* PDF Viewer Container */}
          <div style={{
            backgroundColor: "rgba(17, 17, 17, 0.8)",
            borderRadius: "8px",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            padding: "1.5rem",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)"
          }}>
            {isLoading && (
              <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "600px",
                color: "rgba(255, 255, 255, 0.7)"
              }}>
                <div style={{ textAlign: "center" }}>
                  <div style={{
                    width: "50px",
                    height: "50px",
                    border: "3px solid rgba(210, 255, 31, 0.3)",
                    borderTop: "3px solid #d2ff1f",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                    margin: "0 auto 1rem"
                  }}></div>
                  <p>Loading whitepaper...</p>
                </div>
              </div>
            )}
            <iframe
              src="/assets/whitepaper.pdf#toolbar=1&navpanes=1&scrollbar=1"
              title="AIFL Whitepaper"
              style={{
                width: "100%",
                height: "calc(100vh - 200px)",
                minHeight: "800px",
                border: "none",
                borderRadius: "4px",
                display: isLoading ? "none" : "block"
              }}
              onLoad={() => setIsLoading(false)}
            />
            <style>{`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}</style>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Whitepaper;
